import { extractNumber } from '../utility/fieldFormatters';

export const FIELD_TYPE = {
  COMMA_NUMERIC: 'commaNumeric',
  COMMA_NUMERIC_GRATER_THAN_ZERO: 'commaNumericGraterThanZero',
  TERM: 'term'
};

const isNumberWithCommasGreaterThanZero = (value) => {
  let v = value;
  if (typeof (value) === 'number') {
    v = value.toString();
  }
  const convertedVal = v ? v.trim() : '';
  const n = extractNumber(convertedVal);
  if (isNaN(n)) {
    return false;
  }

  if (n <= 0) {
    return false;
  }

  return true;
};

const isNumberWithCommas = (value) => {
  let v = value;
  if (typeof (value) === 'number') {
    v = value.toString();
  }
  const convertedVal = v ? v.trim() : '';
  if (isNaN(extractNumber(convertedVal))) {
    return false;
  }
  return true;
};

const isNumberWithOptionalTerm = (value) => {
  const UNITS = 'DMY';
  const unit = value.substring(value.length - 1).toUpperCase();
  const quantity = UNITS.indexOf(unit) !== -1
    ? value.substring(0, value.length - 1)
    : value;

  return !isNaN(quantity);
};

const requiredValidators = {
  commaNumeric: [isNumberWithCommas],
  commaNumericGraterThanZero: [isNumberWithCommasGreaterThanZero],
  term: [isNumberWithOptionalTerm]
};

export const getRequiredValidators = (fieldType) => {
  const validators = requiredValidators[fieldType] || [];
  return validators;
};

export const validateAllFields = (fields) => {
  let failedValidations = 0;
  Object.values(fields).forEach((field) => {
    if (field && !field.validate()) {
      failedValidations += 1;
    }
  });
  return failedValidations === 0;
};

export const clearErrorsAllFields = (fields) => {
  Object.values(fields).forEach((field) => {
    if (field) {
      field.clearErrors();
    }
  });
};

export const isInExecutedState = rec => rec.ExecutionStatus === 'Executed' || (rec.ExecutionDate !== undefined && rec.ExecutionDate !== null);

export const isClientRateMandatory = rec => rec.OrderType && !rec.OrderType.startsWith('Market Order ') && !rec.OrderType.startsWith('At Market');



// WEBPACK FOOTER //
// ./src/utility/validators.js